export const stateKey = (schemaId: string, objectId: string): string => {
    return `${schemaId}_${objectId}`;
}